<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('absent_log')">
        </app-page-top-section>
        <app-table
            :id="tableId"
            :options="options"
            @getFilteredValues="setQueryObject"
        />

    </div>
</template>

<script>
import AttendanceAbsentLogMixin from "../../Mixins/AttendanceAbsentLogMixin";
import {urlGenerator} from "../../../../common/Helper/AxiosHelper";
import {formatDateForServer, localTimeZone} from "../../../../common/Helper/Support/DateTimeHelper";

export default {
    name: "AbsentLog",
    mixins: [AttendanceAbsentLogMixin],
    data() {
        return {
            urlGenerator,
            tableId: 'absent-log'
        }
    },
    methods: {
        setQueryObject(obj) {
            this.queryObject = obj;
        }
    }
}
</script>
